import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const Container = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "30px",
  width: "100%",
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: "black",
  [theme.breakpoints.down("md")]: {
    ...theme.typography.h3,
  }
}));

const StepsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "20px",
  width: "100%",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    gap: "12px",
  },
}));

const StepCard = styled(Box)(({ theme }) => ({
  backgroundColor: "var(--background-step)",
  borderRadius: "20px",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  height: "160px",
  flex: "1 1 0",
  minWidth: 0,
  [theme.breakpoints.down("md")]: {
    minHeight: "160px",
    height: "auto",
    padding: "18px",
  },
}));

const StepNumber = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 600,
  color: "rgba(0, 0, 0, 0.4)",
  lineHeight: "normal",
}));

const StepText = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  fontWeight: 600,
  color: "black",
  lineHeight: "normal",
}));

const Disclaimer = styled(Typography)(() => ({
  fontSize: "14px",
  fontWeight: 400,
  color: "rgba(0, 0, 0, 0.4)",
  lineHeight: "normal",
}));

export default function HowItWorksProcess() {
  return (
    <Container>
      <SectionTitle>Как мы работаем</SectionTitle>

      <StepsContainer>
        <StepCard>
          <StepNumber>ШАГ 1</StepNumber>
          <StepText>
            Пользователь проходит KYC → UAE компания (Sum&Substance).
          </StepText>
        </StepCard>

        <StepCard>
          <StepNumber>ШАГ 2</StepNumber>
          <StepText>
            Средства в RUB → Киргизская компания (FX конвертация).
          </StepText>
        </StepCard>

        <StepCard>
          <StepNumber>ШАГ 3</StepNumber>
          <StepText>Баланс в EUR/USD доступен в кошельке.</StepText>
        </StepCard>

        <StepCard>
          <StepNumber>ШАГ 4</StepNumber>
          <StepText>Все операции проходят AML/санк-чек.</StepText>
        </StepCard>
      </StepsContainer>

      <Disclaimer>
        Все данные пользователей обрабатываются и хранятся по международным
        стандартам (EEA, UK и др.), доступ к полной документации — по NDA
      </Disclaimer>
    </Container>
  );
}
